import styled from "styled-components"
import LoginForm from "../../components/User/LoginPage/LoginForm"
import Footer from "../../components/common/Footer"
import Header from "../../components/common/Header"
import useScrollReset from "../../hooks/useScrollReset"

const LoginPage = () => {
  useScrollReset()

  return (
    <LoginPageContainer>
      <Header />
      <LoginContent>
        <LoginForm />
      </LoginContent>
      <Footer />
    </LoginPageContainer>
  )
}

export default LoginPage

const LoginPageContainer = styled.div`
  height: 100vh;
`

const LoginContent = styled.div`
  padding-top: 60px;
  height: calc(100vh - 260px);
`
